import { Component } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../Services/user.service';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [HttpClientModule, FormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  providers: [UserService],
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  version: string = '';
  constructor(private _userservice: UserService, private router: Router) {
    this.version=environment.version;
  }

  loginUser() {
    this._userservice.login(this.username, this.password).subscribe({
      next: (response: any) => {
        if (response) {
          this._userservice.saveToken(response);
          this.router.navigate(['/']);
        }
      },
      error: (error) => {
        const parsedError = JSON.parse(error.error);
        const message = parsedError.message;
        Swal.fire({
          text: message,
          icon: 'error',
          timer: 3000,
          confirmButtonText: 'OK',
        });
      },
    });
  }
}
